import styled from "styled-components";

export const CMAuctionAbout = styled.div((props) => ({
  "&.dotted-border": {
    paddingBottom: "20px",
  },

  ".MuiPaper-root": {
    boxShadow: "unset",

    "& .MuiAccordionSummary-root, & .MuiAccordionDetails-root": {
      padding: 0,

      "& h4, & h3": {
        fontWeight: 500,
        fontFamily: props.theme.fontFamilies.workSans,
      },
    },
  },
}));

export const CMArtistBio = styled.div((props) => ({
  fontWeight: "400",
  fontFamily: props.theme.fontFamilies.jost,

  "& > *": {
    marginLeft: 0,
    marginRight: 0,
  },
}));

export const CMTrackList = styled.div((props) => ({
  "& h3": {
    fontSize: props.theme.fontSizes.h4,
  },
}));
